/* Progressive enhancement for versioned Anatomy turning-group models. */
(()=>{
  const boot=async root=>{
    if(root.dataset.mounted)return;
    root.dataset.mounted='loading';
    const fallback=root.querySelector('[data-fallback]'),live=root.querySelector('[data-interactive]');
    let controller,painter,observer,frame=0,disposed=false;
    try{
      const response=await fetch(root.dataset.modelUrl);
      if(!response.ok)throw new Error('Model unavailable');
      const model=await response.json();
      if(disposed||!root.isConnected)return;
      const stage=root.querySelector('[data-stage]');
      const fail=()=>{disposed=true;live.hidden=true;fallback.hidden=false;root.dataset.mounted='fallback';cancelAnimationFrame(frame);};
      controller=window.ToeeTireGL.mount(stage,model,fail);
      painter={paint:()=>controller.paint(),destroy:()=>{}};
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let angle=0,target=0,last=0,visible=false,tour=false,drag=null,selected='overview';
      const normalize=a=>((a%360)+360)%360;
      const readout=root.querySelector('[data-angle]'),toggle=root.querySelector('[data-auto]');
      const pick=(x,y)=>controller.pick(x,y);
      const titles=model.titles;
      const descriptions=model.descriptions;
      const describe=key=>{
        selected=titles[key]?key:'overview';
        root.querySelector('[data-title]').textContent=titles[selected];
        root.querySelector('[data-description]').textContent=descriptions[selected];
        root.querySelectorAll('[data-select]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.select===selected)));
        root.dataset.selected=selected;
        root.dataset.selectedParts=String(model.turn.parts.filter(p=>p.name.split('.')[0]===selected).length);
        controller.select(selected);
      };
      const say=()=>stage.setAttribute('aria-label',`Rotatable radial tire cutaway, ${Math.round(normalize(target))} degrees. Use left and right arrow keys to rotate; Home resets. Use component buttons for explanations.`);
      const stopTour=()=>{tour=false;toggle.setAttribute('aria-pressed','false');toggle.textContent='Auto rotate';};
      function tick(now){
        frame=0;
        if(disposed||!visible||document.hidden)return;
        const dt=last?Math.min((now-last)/1000,1/30):1/60;last=now;
        if(tour&&!reduced.matches)target+=dt*10;
        angle=reduced.matches?target:angle+(target-angle)*(1-Math.exp(-dt/0.12));
        if(Math.abs(target-angle)<.02)angle=target;
        controller.set({tire:angle});
        readout.textContent=`${Math.round(normalize(angle))}\u00b0 \u00b7 quarter cutaway`;
        root.dataset.angle=angle.toFixed(2);
        if(tour||angle!==target)frame=requestAnimationFrame(tick);
      }
      const run=()=>{if(!frame&&visible&&!document.hidden&&!disposed){last=0;frame=requestAnimationFrame(tick);}};
      const rotate=delta=>{stopTour();target+=delta;say();run();};
      root.querySelector('[data-left]').onclick=()=>rotate(-20);
      root.querySelector('[data-right]').onclick=()=>rotate(20);
      root.querySelector('[data-reset]').onclick=()=>{stopTour();target=angle-normalize(angle);say();describe('overview');run();};
      toggle.onclick=()=>{tour=!tour&&!reduced.matches;toggle.setAttribute('aria-pressed',String(tour));toggle.textContent=tour?'Pause rotation':'Auto rotate';run();};
      root.querySelectorAll('[data-select]').forEach(b=>b.onclick=()=>{stopTour();describe(b.dataset.select);});
      stage.addEventListener('keydown',e=>{
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();rotate((e.key==='ArrowLeft'?-1:1)*(e.shiftKey?45:10));}
        if(e.key==='Home'){e.preventDefault();root.querySelector('[data-reset]').click();}
        if(e.key==='Escape')stopTour();
      });
      stage.addEventListener('pointerdown',e=>{if(e.button!==0)return;stopTour();drag={id:e.pointerId,x:e.clientX,start:target,moved:false,part:pick(e.clientX,e.clientY)};stage.setPointerCapture(e.pointerId);});
      stage.addEventListener('pointermove',e=>{if(!drag||drag.id!==e.pointerId)return;const dx=e.clientX-drag.x;if(Math.abs(dx)>5)drag.moved=true;if(drag.moved){target=drag.start+dx*240/stage.clientWidth;run();}});
      const release=e=>{if(!drag||drag.id!==e.pointerId)return;if(e.type==='pointerup'&&!drag.moved&&drag.part)describe(drag.part);if(stage.hasPointerCapture(e.pointerId))stage.releasePointerCapture(e.pointerId);drag=null;say();};
      stage.addEventListener('pointerup',release);stage.addEventListener('pointercancel',release);
      stage.addEventListener('focus',stopTour);
      const motion=()=>{if(reduced.matches)stopTour();toggle.disabled=reduced.matches;toggle.title=reduced.matches?'Automatic motion is disabled by your reduced-motion preference':'';run();};
      reduced.addEventListener('change',motion);motion();
      const visibility=()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else run();};
      document.addEventListener('visibilitychange',visibility);
      observer=new IntersectionObserver(entries=>{visible=entries.at(-1).isIntersecting;if(visible)run();else{cancelAnimationFrame(frame);frame=0;}},{rootMargin:'120px 0px'});observer.observe(stage);
      root._toeeDispose=()=>{disposed=true;cancelAnimationFrame(frame);observer.disconnect();painter.destroy();controller.destroy();reduced.removeEventListener('change',motion);document.removeEventListener('visibilitychange',visibility);};
      describe('overview');say();live.hidden=false;fallback.hidden=true;root.dataset.mounted='ready';
    }catch(error){painter?.destroy();controller?.destroy();observer?.disconnect();cancelAnimationFrame(frame);live.hidden=true;fallback.hidden=false;root.dataset.mounted='fallback';console.warn('Toee anatomy: static illustration retained.',error.message);}
  };
  const scan=scope=>scope.querySelectorAll('[data-toee-anatomy]').forEach(root=>boot(root));
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-toee-anatomy]').forEach(root=>root._toeeDispose?.()));
})();
